export default __webpack_public_path__ + "static/media/flash03.9f1a45fe.png";